export const componentWhiteList = new Set([
  'GeneralContent',
]);
